export default __webpack_public_path__ + "static/media/animation.50c83c01.gif";